module.exports = __webpack_public_path__ + "static/media/logo-zh-Hant.8488c6b3.png";